/**
 * Central site config.
 *
 * If you ever move the domain or want to point at a staging URL, change
 * SITE_URL below (or set REACT_APP_SITE_URL in /app/frontend/.env to override).
 */
export const SITE_URL =
  (typeof process !== "undefined" && process.env.REACT_APP_SITE_URL) ||
  "https://upgradecost.com";

export const SITE_NAME = "UpgradeCost";

export const SITE_TAGLINE = "Home Upgrade Cost Calculator";

export const SITE_DESCRIPTION =
  "Free bathroom remodel cost calculator with hidden-cost warnings and a printable contractor brief. Get your real cost range in under 2 minutes.";

export const DEFAULT_OG_IMAGE =
  "https://images.pexels.com/photos/7045908/pexels-photo-7045908.jpeg?auto=compress&cs=tinysrgb&w=1200&h=630&fit=crop";

export const buildUrl = (path = "") => {
  const trimmed = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${trimmed === "/" ? "" : trimmed}`;
};
